export default "__VITE_ASSET__81fb4ddf__"